import React from 'react';

/**
 * Bloc « À faire » : texte du dictionnaire (plain) ou description Lighthouse (HTML + liens).
 */
export default function LighthouseActionText({ translation, rawDescription, className = '' }) {
  if (!translation) return null;

  const html = !translation.known && (translation.descriptionHtml || rawDescription);
  if (translation.known && translation.corriger) {
    return (
      <p className={`text-sm text-blue-gray-700 mt-1.5 ${className}`}>
        <span className="font-medium text-blue-gray-800">À faire : </span>
        {translation.corriger}
      </p>
    );
  }
  if (html) {
    return (
      <div
        className={`text-sm text-blue-gray-700 mt-1.5 leading-relaxed [&_a]:text-accent [&_a]:font-medium [&_a]:underline [&_a]:hover:opacity-80 ${className}`}
      >
        <span className="font-medium text-blue-gray-800">À faire : </span>
        <span dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    );
  }
  return null;
}
